import React from 'react';
import { XIcon } from 'lucide-react';
import { handoffs, noMores, simpleMessages } from '../data/content';
import { CtaButton } from './CtaButton';
import { PrintCutShare } from './PrintCutShare';
const tones = ['text-navy', 'text-coral', 'text-navy', 'text-leaf-deep'];
export function SolutionIntro() {
  return <section aria-labelledby="solution-title" className="bg-cream" data-id="element-317" data-mp="3qe8zspa3jifu">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-318" data-mp="hxnm4v6is16e">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-319" data-mp="hv9w50qp5f5p">
          <div data-id="element-320" data-mp="lxod1fat24uc">
            <h2 id="solution-title" className="text-balance font-display text-[38px] leading-[1.05] text-navy sm:text-5xl" data-id="element-321" data-mp="ly6fwurz3hb8">
              What If You Had a Simple Way to Start?
            </h2>
            <ul className="mt-8 space-y-2" data-id="element-322" data-mp="cwq5in15rf70">
              {simpleMessages.map((m, i) => <li key={m} className={`font-display text-2xl leading-snug sm:text-[30px] ${tones[i]}`} data-id="element-323" data-mp="2snuhstz50583" data-mpi={i}>
                  {m}
                </li>)}
            </ul>
          </div>
          <div className="lg:pt-4" data-id="element-324" data-mp="2xapdeuxntjb3">
            <p className="text-lg font-bold text-navy" data-id="element-325" data-mp="2xbqzdug7rq7l">Something small enough to…</p>
            <ul className="mt-5 divide-y divide-cream-line border-y border-cream-line" data-id="element-326" data-mp="2taf7tjds4uwr">
              {handoffs.map(h => <li key={h} className="py-3.5 text-lg text-ink-soft" data-id="element-327" data-mp="329admucww2zj">
                  {h}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-20 max-w-3xl text-center" data-id="element-328" data-mp="3g6p5e5qn0muo">
          <p className="font-display text-3xl leading-tight text-navy sm:text-4xl" data-id="element-329" data-mp="3c6589262dj8j">That’s why the Gospel Sharing Mega Bundle was created.</p>
          <p className="mt-5 text-lg leading-relaxed text-ink-soft" data-id="element-330" data-mp="3q0ft38exwt9b">
            A complete collection of <strong className="text-navy" data-id="element-331" data-mp="3l1laa6gz34p7">200+ Bible verses</strong> across{' '}
            <strong className="text-navy" data-id="element-332" data-mp="3rws4tkqakx9">20+ different printable designs</strong> created to help everyday Christians begin sharing God’s Word
            in a simple, practical and creative way.
          </p>
          <ul className="mt-8 flex flex-wrap justify-center gap-3" data-id="element-333" data-mp="5xbdyb0asqv3">
            {noMores.map(n => <li key={n} className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 font-semibold text-ink-soft shadow-card" data-id="element-334" data-mp="asighfhtzpif">
                <XIcon className="h-4 w-4 text-coral" strokeWidth={3} aria-hidden="true" data-id="element-335" data-mp="kkwfw1lfsk1f" />
                {n}
              </li>)}
          </ul>
          <p className="mt-10 font-display text-2xl italic text-ink-soft" data-id="element-336" data-mp="plk7aodkv2w6">Just…</p>
          <div className="mt-3" data-id="element-337" data-mp="tj9k00f50low">
            <PrintCutShare data-id="element-338" data-mp="yk5y16t7do81" />
          </div>
          <p className="mt-3 font-display text-2xl text-leaf-deep" data-id="element-339" data-mp="ylh2l8uh3007">And start planting seeds.</p>
          <CtaButton className="mt-8" data-id="element-340" data-mp="13i7hvtygdrkk">Get Instant Access</CtaButton>
        </div>
      </div>
    </section>;
}